import {LinearProgress, Box, Typography, Checkbox, FormControlLabel} from '@mui/material'
import {styled} from '@mui/material/styles'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const classesP = {
  background: `background`,
  disable: `disable`,
  hoverBackground: `hoverBackground`,
  textFS: `textFS`,
  stackFS: `stackFS`,
  colorHpPrimary: `colorHpPrimary`
}

const CustomLinearProgress = styled(LinearProgress)(({theme, id}) => ({
  marginTop: 14,
  height: '16px',
  marginRight: 0.5,
  backgroundColor: 'transparent',
  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.palette.personaColor?.[id]?.[0]
  }
}))

const CustomBox = styled(Box, {shouldForwardProp: (prop) => prop !== 'personaSidebar'})(({theme, personaSidebar}) => ({
  position: 'absolute',
  right: '70px',
  top: '10px',
  padding: '10px',
  cursor: 'default',
  zIndex: 5,
  width: '347px',
  borderRadius: '4px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  backgroundColor: theme.palette.primary.contrastText,

  // summary sidebar component here...
  marginRight: 0,
  ...(personaSidebar && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  }),

  [`& .${classesP.background}`]: {
    backgroundColor: `${theme.palette.hpPrimaryLightest} !important`
  },
  [`& .${classesP.disable}`]: {
    cursor: 'not-allowed',
    color: theme.palette.grey[500]
  },
  [`& .${classesP.textFS}`]: {
    fontSize: theme.typography.labelSmall?.fontSize,
    fontStyle: 'italic',
    color: theme.palette.hpBaseDarker,
    marginLeft: 9
  },
  [`& .${classesP.hoverBackground}`]: {
    '&:hover': {backgroundColor: theme.palette.hpBaseLighter}
  },

  [`& .${classesP.stackFS}`]: {
    alignSelf: 'center',
    marginTop: 1.5,
    marginBottom: 1,
    marginLeft: '30%'
  },
  [`& .${classesP.colorHpPrimary}`]: {
    color: theme.palette.hpPrimary
  }
}))

const CustomFormControlLabel = styled(FormControlLabel)(({theme}) => ({
  ...theme.typography.body2,
  marginRight: 0,
  fontFamily: theme.typography.fontFamily
}))

const CustomCheckbox = styled(Checkbox)(({theme}) => ({
  color: theme.palette.primary.dark,
  cursor: 'pointer',
  marginTop: 1,
  '&.Mui-unchecked': {
    color: theme.palette.primary.dark
  }
}))

const StyledPersonaText = styled(Typography)(({theme, id}) => ({
  ...theme.typography.body2,
  font: theme.typography.fontFamily,
  color: theme.palette.hpBaseDark,
  marginTop: '4px',
  fontSize: theme.typography[id]?.fontSize
}))

const StyledSummaryDiv = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  color: theme.palette.hpPrimary,
  fontFamily: theme.typography.fontFamily,
  marginTop: '4px',
  marginBottom: '4px'
}))

const StyledSummaryText = styled(Typography)(({theme}) => ({
  font: theme.typography.fontFamily,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  cursor: 'pointer',
  marginLeft: '4px',
  '&:hover': {
    textDecoration: 'underline'
  }
}))

const StyledDivWarning = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  font: theme.typography.fontFamily,
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.hpAccentRed,
  marginTop: '8px'
}))

const StyledWarningText = styled(Typography)(() => ({
  marginLeft: '8px'
}))

const StyledTextPercentage = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.body2.fontSize,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.hpBaseDark,
  marginTop: 13,
  marginLeft: 0.5,
  marginRight: 1
}))

const StyledButtonDiv = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  backgroundColor: 'transparent',
  color: theme.palette.pBlue500,
  '&:hover': {
    textDecoration: 'underline',
    backgroundColor: 'transparent',
    outline: 'none'
  }
}))
const StyledPersonaTitle = styled(Typography)(({theme}) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  marginLeft: '4px'
}))

const StyledHandleDragDiv = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
}))

const StyledMainDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  alignItems: 'center'
}))

const StyledCheckboxText = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.body2.fontSize,
  fontFamily: theme.typography.fontFamily,
  marginTop: 13,
  marginLeft: -20,
  cursor: 'pointer'
}))

const StyledDragIndicatorIcon = styled(DragIndicatorIcon)(({theme}) => ({
  color: theme.palette.hpBaseDark
}))
const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)(({theme}) => ({
  color: theme.palette.hpBaseDark
}))
const StyledKeyboardArrowUpIcon = styled(KeyboardArrowUpIcon)(({theme}) => ({
  color: theme.palette.hpBaseDark
}))
export {
  CustomLinearProgress,
  CustomBox,
  StyledButtonDiv,
  StyledTextPercentage,
  CustomCheckbox,
  CustomFormControlLabel,
  StyledDivWarning,
  StyledWarningText,
  StyledSummaryDiv,
  StyledSummaryText,
  StyledPersonaText,
  StyledPersonaTitle,
  StyledHandleDragDiv,
  StyledMainDiv,
  StyledDragIndicatorIcon,
  StyledKeyboardArrowDownIcon,
  StyledKeyboardArrowUpIcon,
  StyledCheckboxText,
  classesP
}
